import i18n from 'i18next';

import getAudienceTypes from '../helpers/getAudienceTypes';

export default () => ({
  name: {
    type: 'Text',
    label: i18n.t('audience-name'),
    help: i18n.t('audience-name-help'),
    maxLength: 256,
    placeholder: i18n.t('audience-name-placeholder'),
    validators: [{ type: 'isNotEmptyString' }, { type: 'isRequired' }],
  },
  summary: {
    type: 'TextArea',
    label: i18n.t('audience-summary'),
    validators: [{ type: 'isNotEmptyString' }, { type: 'isRequired' }],
  },
  audience_type: {
    type: 'RadioCards',
    label: i18n.t('audience-type'),
    help: i18n.t('audience-type-help'),
    options: getAudienceTypes(),
    validators: [{ type: 'isRequired' }],
  },
});
